import React, { useEffect, useState, useRef } from 'react';

import { Grid, MenuItem, Button } from '@material-ui/core';

import { Form, Input, Select as SelectAntd, Spin } from 'antd';
import { useSnackbar } from 'notistack';
import ButtonComponent from '@components/Shared/Buttons/Button';
import Service from './services';

interface IProps {
  id_lote: any;
  finish?: Function;
}

const ModalRecusaComponent: React.FC<IProps> = ({
  id_lote,
  finish

}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [formRef] = Form.useForm();

  const [loading, setLoading] = useState(true);
  const [loadingApproveSolicitacao, setLoadingApproveSolicitacao] =
    useState(false);

  useEffect(() => {
    const init = async () => {
      const service = new Service();
    };

    init();
    setLoading(false);
  }, []);

  async function onSubmit(values: any) {
    setLoading(true);

    let ids_lote: number[] = [];

    ids_lote = id_lote;

    const componentRecuseSolicitacaoServices = new Service();

    const response = await componentRecuseSolicitacaoServices.RecusarDoacoes(id_lote, values.observacao);
    if (!response.error) {
      enqueueSnackbar('Doação recusada com sucesso!', { variant: 'success' });

      if (finish) {
        setLoading(false);
        await finish();
      }
    } else {
      enqueueSnackbar('Erro ao aprovar doações', { variant: 'error' });
    }
    setLoading(false);


    //window.location.reload();
  };

  return (
    <Grid container>
      <Grid container item sm={12}>
        <Spin
          size="large"
          spinning={loadingApproveSolicitacao}
          tip={loadingApproveSolicitacao ? 'Enviando dados...' : ''}
        >
          <Grid
            container
            item
            xs={12}
            md={12}
            justify="center"
            alignItems="center"
          >
            <Form form={formRef}  onFinish={onSubmit} style={{ width: '100%' }} layout="vertical">
              <Grid item lg={12} xs={12}>
              Clique em confirmar para recusar a(s) doação(ões) selecionadas.
              </Grid>

              <Grid item lg={12} xs={12} style={{ paddingRight: 10, paddingLeft: 10 }}>
                      <Form.Item
                        label='Motivo da recusa'
                        name="observacao"
                        rules={[
                          { required: true, message: 'Campo obrigatorio' },
                        ]}
                      >
                        <Input style={{height: 50}}/>
                      </Form.Item>
                    </Grid>

              <Grid container justify="center" alignItems="center">
                <Grid item sm={6} xs={12} style={{ paddingTop: 10 }}>
                  <ButtonComponent
                    color="secondary"
                    fullWidth
                    type="submit"
                    //onClick={handleRecuseLote}
                  >
                    Confirmar
                  </ButtonComponent>
                </Grid>
              </Grid>
            </Form>
          </Grid>
        </Spin>
      </Grid>
    </Grid>
  );
};

export default ModalRecusaComponent;
